import { Trans, msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import CollectionsIcon from '@mui/icons-material/Collections';
import DeleteIcon from '@mui/icons-material/Delete';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import VerifiedIcon from '@mui/icons-material/Verified';
import { Backdrop, Box, Button, CircularProgress, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { useRef, useState } from "react";
import httpReq from "../../ce-services/http-req";
import { saveToIndexedDB } from "../../utils";
import ModalPreviewImage from "../modals/reportAccident/ModalPreviewImage";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import SaveIcon from '@mui/icons-material/Save';

const FourthPage = ({ setDataSaved, isMobile, images, setImages, pageIndex, setPageIndex, draft, setDraft, isOnline, resetForm, setSelectedVehicleTypes, setSelectedRegion }) => {
  const cameraRef = useRef(null);
  const { _ } = useLingui();
  const [isSavedAsADraft, setIsSavedAsADraft] = useState(false);
  const [isSavedAsFinal, setIsSavedAsFinal] = useState(false);
  const [publicAccidentId, setPublicAccidentId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [photoPreview, setPhotoPreview] = useState(null);

  const saveAsDraft = async () => {
    const draftImages = { publicAccidentImages: images };
    const dt = Object.assign(draft, draftImages);

    resetForm();
    localStorage.removeItem('temporaryCoords');
    setDataSaved(true);
    setSelectedRegion(null);
    setImages([]);
    await saveToIndexedDB(dt, true);
    setIsSavedAsADraft(true);
  };

  const saveReport = async () => {
    setIsLoading(true);
    const publicAccident = draft.publicAccident;


    const publicAccidentImages = images;
    const publicAccidentVehicleTypes = draft.publicAccidentVehicleTypes;
    const resPublicAccident = await httpReq('PublicAccident/Insert', 'POST', publicAccident, false);

    setPublicAccidentId(resPublicAccident.responseData.id);
    if (!resPublicAccident.responseAnyError) {
      const reqSaveVehicleTypes = publicAccidentVehicleTypes.map(async (vehicle) => {
        const data = {
          admount: vehicle.admount,
          vehicleTypeFk: vehicle.id,
          publicAccidentFk: resPublicAccident.responseData.id
        };
        const res = await httpReq('PublicAccidentVehicle/Insert', 'POST', data, false);
        if (!res.responseAnyError) {
          return res.responseData;
        }
      });
      await Promise.all(reqSaveVehicleTypes).then(async () => {
        if (publicAccidentImages.length > 0) {
          const req = publicAccidentImages.map(async (image) => {
            image.publicAccidentFk = resPublicAccident.responseData.id;
            const res = await httpReq('PublicAccidentAttachment/Insert', 'POST', image, false);
            return res.responseData;
          });
          await Promise.all(req).then(() => {
            setIsLoading(false);
            resetForm();
            localStorage.removeItem('temporaryCoords');
            setDataSaved(true);
            setSelectedRegion(null);
            setImages([]);
            localStorage.removeItem('temporaryCoords');
            setIsSavedAsFinal(true);
          });
        } else {
          setIsLoading(false);
          localStorage.removeItem('temporaryCoords');
          setDataSaved(true);
          setImages([]);
          setSelectedRegion(null);
          resetForm();
          setIsSavedAsFinal(true);
        }

      });
    }

  };

  const InsertImages = () => {
    return (
      <>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
          <Typography sx={{ fontWeight: 700 }}>{_(msg`Take or load pictures`)}</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: isMobile ? 2 : 4 }}>
            <Tooltip title={_(msg`Back`)}>
            <IconButton onClick={() => {
                setPageIndex(pageIndex - 1);
              }} variant="contained" sx={{ display: 'flex', flex: 1 }}>
              <ArrowBackIosNewIcon />
            </IconButton>
              </Tooltip>
            <Tooltip title={_(msg`Save as draft`)}>
            <IconButton onClick={() => saveAsDraft()} variant="contained" sx={{ display: 'flex', flex: 1 }}>
              <EditCalendarIcon />
            </IconButton>
            </Tooltip>
            <Tooltip title={_(msg`Save`)}>
            <IconButton disabled={!isOnline} onClick={() => saveReport()} sx={{ display: 'flex', flex: 1 }}>
              <SaveIcon />
            </IconButton>
            </Tooltip>
          </Box>
        </Box>

        <Grid container direction='row' spacing={1} justifyContent={isMobile ? 'space-between' : 'center'} sx={{ mt: 1.5 }}>
          {/* Button for Library Upload */}
          <Grid item xs={12}>
            <Button
              fullWidth
              variant='contained'
              component="label"
              size={isMobile ? 'medium' : 'large'}
              startIcon={<CollectionsIcon />}>
              
              {isMobile ? <Trans>Upload or take pictures</Trans> : <Trans>Upload picture</Trans>}
              <input
                type='file'
                accept='image/*'
                // capture='environment'
                hidden
                onChange={(event) => {
                  // handleFileChange(event)
                  const files = event.target.files;
                  if (files.length) {
                    [...files].forEach((file) => {
                      const filereader = new FileReader();
                      filereader.readAsDataURL(file);
                      // eslint-disable-next-line no-loop-func
                      filereader.onload = (evt) => {
                        const base64 = evt.target.result;

                        const base64Split = base64.split(',');

                        const data = {
                          title: file.name,
                          description: file.name,
                          fileName: file.name,
                          fileType: file.type,
                          fileContent: base64Split[1]
                          // publicAccidentFk: publicAccident.id
                        };

                        setImages([...images, data]);

                      };
                    });
                  }
                }} />
              
            </Button>
          </Grid>

        </Grid>
        <Box sx={{ height: '50vh', maxHeight: '50vh', overflowY: 'auto', marginTop: 2 }}>
          {images.length > 0 &&
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'space-between' }}>
              {images.map((image) => {

              return (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <Typography>{image.fileName}</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
                      <IconButton onClick={() => {
                      setPhotoPreview(image);
                    }}><OpenInFullIcon /></IconButton>
                      <IconButton onClick={() => {
                      const imagesCopy = [...images];
                      const idx = imagesCopy.findIndex((i) => {
                        return i.title === image.title;
                      });
                      if (idx !== -1) {
                        imagesCopy.splice(idx, 1);
                        setImages(imagesCopy);
                      } else {
                        return;
                      }
                    }}><DeleteIcon /></IconButton>
                    </Box>
                  </Box>);

            })}
            </Box>

          }
        </Box>

        {photoPreview && <ModalPreviewImage isMobile={isMobile} image={photoPreview} setImage={setPhotoPreview} />}
      </>);

  };

  const SavedAsDraftHtml = () => {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography>{_(msg`Thanks! Your report has been saved as a draft. You can find it in the draft list on the home page`)}</Typography>
        <Button variant="contained" sx={{ marginTop: 2 }} onClick={() => {setPageIndex(0);}}>
          {_(msg`Return to home`)}
        </Button>
      </Box>);

  };

  const SavedAsFinalHtml = () => {
    return (
      <>
        <Box display={'flex'} flex={1} marginTop={'20%'} justifyContent={'center'} alignItems={'center'} height={'50%'} width={'100%'} flexDirection={'column'}>
          <Typography variant='h3' sx={{ fontSize: 20, textAlign: 'center' }}>{_(msg`${`You sent your segnalation with id ${publicAccidentId}`}`)}</Typography>
          <VerifiedIcon style={{ height: 128 }} sx={{ marginTop: 10, fontSize: 128, color: 'green' }} />
          <Typography variant='h3' sx={{ fontSize: 20, textAlign: 'center', marginTop: 10 }}>{_(msg`Thank you!`)}</Typography>
          <Button variant="contained" sx={{ marginTop: 2 }} onClick={() => {setPageIndex(0);}}>
            {_(msg`Return to home`)}
          </Button>
        </Box>
      </>);

  };

  return (
    <>
      <Box sx={{ padding: 4 }}>
        {!isSavedAsADraft && !isSavedAsFinal && <InsertImages />}
        {isSavedAsADraft && <SavedAsDraftHtml />}
        {isSavedAsFinal && <SavedAsFinalHtml />}
      </Box>
      {isLoading && <Backdrop
        sx={{ color: '#fff', zIndex: 1000 }}
        open={isLoading}>

        
        <CircularProgress color="inherit" />
      </Backdrop>}
    </>);

};
export default FourthPage;